<div class="banner" id="home" [ngClass]="{'arabic': lang === 'ar'}">
  <div class="container">
    <div class="bannerSec row align-items-center">

      <div class="col-12 col-lg-6 col-xl-7 leftSec">
        <h2 class="bannerTitle fw-bold mb-2 subtitle">{{"banner-heading" | translate}} <span
            class="text-secondary">{{"banner-heading1" | translate}} </span></h2><br>
        <p class="bannerDesc fw-regular font-20 mb-3">{{"banner-para" | translate}}</p>
        <div class="d-flex align-items-center justify-content-center justify-content-lg-start mb-5">
          <a href="/assets/documents/whitepaper.pdf" class="btn btn-white text-uppercase wx-200 mt-2 py-3 me-3"
            target="_blank">{{ "whitepaper" | translate}}</a>
          <a href="/assets/documents/audit.pdf" class="btn btnWhitepaper mt-2 wx-200" target="_blank">{{ "audit" |
            translate}}</a>
        </div>
        <p class="bannerpara text-center text-lg-start text-light font-20 mb-3">{{"banner-para2" | translate}}</p>
      </div>

      <div class="col-12 col-lg-6 col-xl-5 right mt-4 mt-lg-0">
        <div class="walletBox" [ngClass]="{'connected': walletAddress}">
          <div
            class="w-100  d-flex flex-column align-items-center justify-content-start p-3 pb-0 text-white text-center">

            <h4 class="text-white text-center family-title mt-4 text-uppercase fs-20 fw-bold"
              [ngClass]="{'shimmer': !dataLoaded}">{{'xrp_sold_out' | translate}}</h4>

            <div class="usdt-val text-center text-white fw-semibold text-uppercase mt-3 "
              [ngClass]="{'shimmer': !dataLoaded}" *ngIf="walletAddress">
              {{"your_purchased" | translate : {tokenName} }} {{convertNum(userClaimable)}}
            </div>

            <!-- <a class="text-white text-decoration-underline cursor-pointer  mt-3" translate (click)="claimStake()"
              *ngIf="userClaimableEth > 0 && walletAddress"
              [ngClass]="{'shimmer': !dataLoaded}">claim_stake_tokens_now</a> -->

          </div>

          <div class="px-3 swapArea"
            [ngClass]="{'cover': status === SwapStatus.in_progess || status === SwapStatus.confirm_pending || status === SwapStatus.approval_pending}">

            <div class="d-flex align-items-center justify-content-center gap-2 mt-3" *ngIf="!walletAddress">
              <button class="btn btn-secondary fs-6 w-80" (click)="connectModal()" translate>connect_wallet</button>
            </div>
            <div class="d-flex align-items-center justify-content-center gap-2 mt-3" *ngIf="walletAddress">
              <button class="btn btn-secondary fs-6 w-80" (click)="claimStake()">{{'claim_stake_apy' | translate:{apy}
                }}</button>
            </div>

            <div translate class="usdt-val text-center text-white fs-7 fw-semibold text-uppercase mt-3 ">apy_desc</div>
            <div class="usdt-val text-center text-white fs-7 fw-semibold text-uppercase mt-3 ">
              <a [href]="lang+'/claim'" class=" text-white text-decoration-underline" translate>just_claim</a>
            </div>
            <div class="d-flex align-items-center justify-content-center gap-2 mt-3" *ngIf="walletAddress">
              <button class="btn btnWhitepaper fs-6 w-80" (click)="disconnect()" translate>{{ walletAddress |
                trimAddress }}</button>
            </div>

            <p class="font-12 text-grey text-center mt-3" translate>powered_by <a
                href="https://web3paymentsolutions.io/" target="_blank"><img
                  src="/assets/images/svg-icons/W3P_White.svg" alt="" class="poweredByIcon"></a></p>
            <!-- <a class="font-15 fw-semibold d-block w-100 text-center mt-2 text-white" href="https://widget.wert.io/default/widget/?commodity=ETH%3AEthereum" target="_blank" translate>not_enough_eth</a> -->
          </div>
        </div>

      </div>


    </div>

    <div class="social-icon mt-3 d-sm-block d-md-none">
      <div class="d-flex justify-content-center align-items-center">
        <!-- <a href="#" target="_blank" class="mx-2">
          <img src="./assets/images/svg-icons/social-icons/discord-icon.svg" alt="">
        </a> -->
        <a href="https://smardex.io/swap?chainId=42161&tokenA=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tokenB=0xe43b45c34e654b1038cecdb57a0302a788fea3f5"
        target="_blank" class="mx-2"> <img src="./assets/images/svg-icons/smardex-icon.svg" class="img-fluid" alt=""></a>
        <a href="https://www.dextools.io/app/en/ether/pair-explorer/0xcd09b73dfeb14233fde9a473878d28cdaf2aa4ed"
          target="_blank" class="mx-2"> <img src="./assets/images/svg-icons/dextools.svg" class="img-fluid" alt=""></a>
        <a href="https://twitter.com/XRP_20" target="_blank" class="mx-2">
          <img src="./assets/images/svg-icons/social-icons/twitter-icon.svg" alt="">
        </a>
        <a href="https://t.me/XRP20_coin" target="_blank" class="mx-2">
          <img src="./assets/images/svg-icons/social-icons/telegram-icon.svg" alt="">
        </a>
      </div>
    </div>
  </div>

  <app-feature></app-feature>
</div>